export const meetingStoreKey = 'meeting';
